const initialState = {
  storageTanks: [],
};

function StorageTanksReducer(state = initialState, action) {
  if (action.type === "STORAGE_TANKS_LIST") {
    var locationDetails = {
      ...state,
      storageTanks: action.payload,
    };
    return locationDetails;
  }

  return state;
}

export default StorageTanksReducer;
